<template>
  <div id="RetirementSheetPage" class="section">
    <div class="columns is-multiline has-text-left">
      <div class="column is-12">
        <h1 class="title">
          RETIREMENT SHEET
        </h1>
      </div>
    </div>
    <div class="container">
      <div class="columns is-multiline has-text-left ">
        <div class="column is-8-desktop is-12-tablet  is-12-mobile">
          <img src="@/assets/documents/retirement_sheet_manual.jpeg" alt="" />
        </div>
        <div class="column is-4-desktop is-12-tablet  is-12-mobile">
          <h1 class="subtitle is-5">
            📄 สรุปแผนการเกษียณ <br />
            แสดงตารางเงินเก็บถอนใช้จ่ายปีต่อปี (รวมเงินเฟ้อ)
          </h1>
          <p>
            🔑เพื่อให้แผนเกษียณเป็นจริง การถ่ายทอดวิธีคิด
            และแผนการที่วางไว้ให้เข้าใจง่าย และสะดวกรวดเร็ว
            จึงเป็นสิ่งสำคัญไม่แพ้การซื้อสินค้าการเงิน (Product)
            <br /><br />

            💡ไอเดีย Plan Do Check Action ประยุกต์เป็นตารางสรุปแผนเกษียณ
            <br /><br />

            จะช่วยให้ลูกค้าเห็นความห่าง(Gap Analysis) ว่าขาด หรือเกิน
            จากเป้าหมายได้ด้วยตัวของเขา
            <br /><br />

            🖼เมื่อเป้าหมายชัด การดำเนินชีวิตของลูกค้าจะมีวินัยมากขึ้น
            และสำเร็จตามฝันที่สร้างร่วมกันไว้ได้
            <br /><br />
          </p>

          <div class="columns">
            <div class="column">
              <p class="title is-6">ดาวโหลดแบบฟอร์ม</p>
              <div class="columns is-mobile is-centered">
                <div class="column">
                  <a @click.prevent="downloadFileAxios('excel')">
                    <figure class="image is-96x96">
                      <img src="@/assets/web_icons/excel_icon.png" />
                    </figure>
                  </a>
                  <p>ไฟล์ Excel</p>
                </div>
                <div class="column">
                  <a @click.prevent="downloadFileAxios('numbers')">
                    <figure class="image is-96x96">
                      <img src="@/assets/web_icons/numbers_icon.png" />
                    </figure>
                  </a>
                  <p>ไฟล์ Numbers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RetirementSheetPage",
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  },
  methods: {
    downloadFileAxios: function(type) {
      let file_extend = "";

      switch (type) {
        case "excel":
          file_extend = ".xlsx";
          break;
        default:
          file_extend = ".numbers";
          break;
      }
      axios({
        url: this.publicPath + "docs/retirement_sheet" + file_extend,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          "แผนเกษียณ_WE_retirement" + file_extend
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    }
  }
};
</script>

<style></style>
